import React from "react";
import AnimatedFavicon from "./components/AnimatedFavicon";
import Home from "./pages/Home";

function App() {
  return (
    <>
      <AnimatedFavicon />
      <a className="skip-link" href="#main-content">
        skip to content
      </a>
      <div className="site-shell">
        <main className="content" id="main-content">
          <Home />
        </main>
      </div>
    </>
  );
}

export default App;
